module.exports = __webpack_public_path__ + "img/C@2x.106c4a0.jpg";